import { IconProps } from './IconProps';

export const Return = (props: IconProps) => {
  return (
    <svg
      className={props.className}
      style={props.style}
      width="20"
      height="14"
      viewBox="0 0 20 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.75346 0V1.42076H13.6992C16.0729 1.42076 17.9616 3.30951 17.9616 5.68319C17.9616 8.05689 16.0729 9.9457 13.6992 9.9457H3.3372L4.61259 8.6703C4.80785 8.47503 4.80785 8.15844 4.61258 7.96318L4.31514 7.66576C4.11988 7.47051 3.8033 7.47052 3.60804 7.66577L0.971234 10.3026C0.775969 10.4978 0.775969 10.8144 0.971234 11.0097L3.60803 13.6464C3.80329 13.8417 4.11988 13.8417 4.31514 13.6464L4.6126 13.349C4.80786 13.1537 4.80785 12.8371 4.61258 12.6419L3.3372 11.3665H13.6992C16.8354 11.3665 19.3824 8.81943 19.3824 5.68319C19.3824 2.54696 16.8354 0 13.6992 0H3.75346Z"
        fill="black"
      />
    </svg>
  );
};

